import { initializeApp, FirebaseOptions } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  connectAuthEmulator,
  Auth,
} from "firebase/auth";
import { getFirestore, Firestore } from "firebase/firestore";

// Firebase configuration using environment variables
const firebaseConfig: FirebaseOptions = {
  apiKey: "AIzaSyAngs3IcDBRLYylbqt204aNZescEM6XQ-w",
  authDomain: "xanathar-fa480.firebaseapp.com",
  projectId: "xanathar-fa480",
  storageBucket: "xanathar-fa480.firebasestorage.app",
  messagingSenderId: "932816787280",
  appId: "1:932816787280:web:ca79fc999b1bd933da7e55",
  measurementId: "G-NMCY79RR04",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth: Auth = getAuth(app);
const db: Firestore = getFirestore(app);

// Connect to auth emulator in development
if (import.meta.env.DEV) {
  try {
    connectAuthEmulator(auth, "http://127.0.0.1:9099");
  } catch (error) {
    if (error instanceof Error) {
      console.log(
        "Auth emulator already connected or not available:",
        error.message,
      );
    }
  }
}

const googleProvider = new GoogleAuthProvider();

// Configure Google provider to prompt for account selection
// and restrict to organization domain
googleProvider.setCustomParameters({
  prompt: "select_account",
  hd: "getplaza.ai", // Restricts to @getplaza.ai accounts only
});

export { auth, db, googleProvider };
